import React, { useEffect, useState } from "react";
import "../NFTDetailDesign.css";
import "./AddAndFetchReaction.css";
import { addComment, addReaction, getComment, getReaction } from "../../../api/nft/nft";
import ErrorMessage from "../../Layouts/ErrorMessage/ErrorMessage";
import { errorMessageHandler } from "../../../utils/utils";
import ReactionsModal from "./ReactionsModal";
import SkeletonLoading from "../../Layouts/SkeletonLoading/SkeletonLoading";

const AddAndFetchReaction = ({ id,currentUser }) => {
    //Add action
    const [reactionLoader, setReactionLoader] = useState(false)
    const [reactionError, setReactionError] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false)

    //Fetch comment
    const [reactionList, setReactionList] = useState([])
    const [reactionListPagination, setReactionListPagination] = useState({})
    const [countReaction, setCountReaction] = useState({})
    const [userReaction, setUserReaction] = useState(null)
    const [fetchReactionLoader, setFetchReactionLoader] = useState(false)
    const [fetchReactionError, setFetchReactionError] = useState("")
    const [fetchReactionPage, setFetchReactionPage] = useState(1)
    const [totalReaction, setTotalReaction] = useState(0)

    useEffect(() => {
        fetchReaction()
    }, [])

    const fetchReaction = async () => {
        try {
            setFetchReactionLoader(true);
            const { data } = await getReaction(id, fetchReactionPage);
            const incoming = data?.data?.reactions || [];
            const pagination = data?.data?.pagination || {};
            if (fetchReactionPage === 1) {
                setCountReaction(data?.data?.counts)
                setUserReaction(data?.data?.userReaction)
                setTotalReaction(data?.data?.pagination?.total_items || 0)
            }
            setReactionList(prev => (fetchReactionPage === 1 ? incoming : [...prev, ...incoming]));

            setReactionListPagination({
                ...pagination,
                current_page: Number(pagination.current_page)
            });
            setFetchReactionLoader(false);
        } catch (e) {
            setFetchReactionLoader(false);
            setFetchReactionError(errorMessageHandler(e));
        }
    };
    //Fetch comment
    useEffect(() => {
        if (fetchReactionPage > 1) fetchReaction();
    }, [fetchReactionPage]);

    const loadMoreListed = () => {
        if (reactionListPagination?.has_next_page) setFetchReactionPage(prev => prev + 1);
    };

    const reactionHandler = async (action) => {
        try {

            if (action === userReaction) {
                return
            }
            setReactionLoader(true);
            setReactionError("");
            const { data } = await addReaction(id, { reaction_type: action });
            const prevReaction = userReaction;
            setUserReaction(data?.data?.reaction_type)
            let isNew = false;
            setReactionList(prev => {

                const index = prev.findIndex(r => r._id === data.data._id);

                if (index !== -1) {
                    // Update the existing reaction
                    const updatedList = [...prev];
                    updatedList[index] = { ...prev[index], ...data.data };
                    return updatedList;
                } else {
                    isNew = true
                    // Add as a new reaction
                    return [data.data, ...prev];
                }
            });
            if (isNew) setTotalReaction(prev => prev + 1);
            setCountReaction(prevCounts => {
                const newCounts = { ...prevCounts };
                if (prevReaction) newCounts[prevReaction] = (newCounts[prevReaction] || 0) - 1;
                newCounts[action] = (newCounts[action] || 0) + 1;
                return newCounts;
            });


            setReactionLoader(false);
        } catch (e) {
            setReactionLoader(false);
            setReactionError(errorMessageHandler(e));
        }
    };




    const reactions = [
        { type: 'like', emoji: '👍', label: 'Like' },
        { type: 'love', emoji: '❤️', label: 'Love' },
        { type: 'fire', emoji: '🔥', label: 'Fire' },
        { type: 'party', emoji: '🎉', label: 'Party' },
        { type: 'dislike', emoji: '👎', label: 'Dislike' }
    ];

    return (
        <>
            <div className="reactions-container">
                {reactions.map(({ type, emoji, label }) => (
                    <button
                        key={type}
                        onClick={() => reactionHandler(type)}
                        className={`reaction-button ${userReaction === type ? 'active' : ''} ${reactionLoader ? 'loading' : ''} reaction-${type}`}
                        disabled={reactionLoader}
                        data-tooltip={label}
                        aria-label={`${label} reaction`}
                    >
                        <span className="reaction-emoji">{emoji}</span>
                        {countReaction[type] > 0 && (
                            <span className="reaction-count">{countReaction[type]}</span>
                        )}
                    </button>
                ))}
                
                {fetchReactionLoader ? (
                    <SkeletonLoading />
                ) : !fetchReactionError && totalReaction > 0 ? (
                    <button
                        className="reactions-view-all"
                        onClick={() => setIsModalOpen(true)}
                        aria-label="View all reactions"
                    >
                        <span>View all</span>
                        <span className="reactions-view-all-count">{totalReaction}</span>
                    </button>
                ) : null}
            </div>

            {reactionError && (
                <div className="reactions-error">
                    <span>⚠️</span>
                    <span>{reactionError}</span>
                </div>
            )}

            <ReactionsModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                reactionsByType={reactionList}
                fetchReactionLoader={fetchReactionLoader}
                fetchReactionError={fetchReactionError}
                loadMoreListed={loadMoreListed}
                totalReactions={totalReaction}
                count={countReaction}
                reactionListPagination={reactionListPagination}
                currentUser={currentUser}
            />
        </>
    );
};

export default AddAndFetchReaction;